import type { MouseEvent } from 'react';
import { NavLink } from 'react-router-dom';
import { ChatClip } from './ChatClip';

export function ChatNavItem({detached,selected,unreadCount,onContextMenu}:{detached:boolean;selected:boolean;unreadCount:number;onContextMenu:(event:MouseEvent<HTMLLIElement>)=>void}) {
  return <li className={`menu-item menu-item--chat${selected?' menu-item--selected':''}${detached?' menu-item--chat-detached':''}`} onContextMenu={onContextMenu}>
    {detached ? <button type="button" className="chat-detached-placeholder" aria-label="Чат открыт в приложении" title="Чат открыт в приложении. Правая кнопка — вернуть чат в браузер." aria-haspopup="menu"/> :
      <NavLink to="/dialogs" aria-label={`Переписка — непрочитанных: ${unreadCount}`} title={`Скрепка · Переписка · Непрочитанных: ${unreadCount}`}>
        <span className="nav-message">
          <ChatClip unreadCount={unreadCount}/>
        </span>
      </NavLink>}
  </li>;
}
